<mat-dialog-content>
  <form [formGroup]="form">
    <h3>Add Booking / Block Dates</h3>

    <div class="form-row">
      <!-- Start Date -->
      <mat-form-field appearance="outline" class="date-field form-field half-width">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>

        <mat-error *ngIf="startDateCtrl?.hasError('required')">
          Start date is required
        </mat-error>
      </mat-form-field>

      <!-- End Date -->
      <mat-form-field appearance="outline" class="date-field form-field half-width">
        <mat-label>End Date</mat-label>
        <input matInput
               [matDatepicker]="endPicker"
               formControlName="endDate"
               [min]="startDateCtrl?.value" />
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>

        <mat-error *ngIf="endDateCtrl?.hasError('required')">
          End date is required
        </mat-error>
        <mat-error *ngIf="endDateCtrl?.hasError('invalidRange') || form.hasError('invalidRange')">
          End date must be after start date
        </mat-error>
      </mat-form-field>

      <!-- Reservation Type -->
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Reservation Type</mat-label>
        <mat-select formControlName="reason">
          <mat-option [value]="null">Select type</mat-option>
          <mat-option *ngFor="let r of reasons" [value]="r">
            {{ r }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="reasonCtrl?.hasError('required')">
          Please select a type
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Reason</mat-label>
        <input matInput formControlName="reasonText">
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button class="metallic-text-btn-red" (click)="onCancel()">
    <mat-icon matPrefix>cancel</mat-icon> Cancel
  </button>
  <button mat-flat-button class="metallic-text-btn-blue" (click)="onSave()" [disabled]="form.invalid">
    <mat-icon matPrefix>save</mat-icon> Save
  </button>
</mat-dialog-actions>